module.exports = __webpack_public_path__ + "static/scale-model-of-whimzeyland-in-clearwater-florida-01149618bfea11acda508b2ee27bf924.png";